// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modules_contentContainer__2xSzA {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  width: auto;
  padding-top: calc(50px + 32px);
}

.Modules_tabsContainer__rUGLa {
  width: 290px;
}

.Modules_tabs__QlKMh {
  max-height: 50vh;
  padding-right: 0.5rem;
  overflow-y: auto;
  margin-right: 1px;
}
.Modules_tabs__QlKMh::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background-color: transparent;
}
.Modules_tabs__QlKMh::-webkit-scrollbar-track {
  border-radius: 0;
}
.Modules_tabs__QlKMh::-webkit-scrollbar-thumb {
  background-color: #bec2c5;
  border-radius: 0;
}

.Modules_modulesContainer__NF-Rw .Modules_moduleThumbnails__03jQ1 {
  height: 55vh;
  padding-right: 0.5rem;
  overflow-y: auto;
  margin-right: 1px;
}
.Modules_modulesContainer__NF-Rw .Modules_moduleThumbnails__03jQ1::-webkit-scrollbar {
  width: 0.5rem;
  height: 0.5rem;
  background-color: transparent;
}
.Modules_modulesContainer__NF-Rw .Modules_moduleThumbnails__03jQ1::-webkit-scrollbar-track {
  border-radius: 0;
}
.Modules_modulesContainer__NF-Rw .Modules_moduleThumbnails__03jQ1::-webkit-scrollbar-thumb {
  background-color: #bec2c5;
  border-radius: 0;
}

.Modules_modulesListTitle__L3P2o {
  padding-left: 0.5rem !important;
}
.Modules_modulesListTitle__L3P2o:has(div > input:checked) {
  background-color: #E9F5F1;
}

.Modules_bundlesListItem__hpDjJ {
  position: relative;
  display: block;
}
.Modules_bundlesListItem__hpDjJ:hover {
  background-color: #F8F9FA;
}
.Modules_bundlesListItem__hpDjJ:hover .content-controls {
  visibility: visible !important;
}
.Modules_bundlesListItem__hpDjJ:has(label > input:checked) {
  background-color: #E9F5F1;
}
.Modules_bundlesListItem__hpDjJ:has(label > input:disabled) label {
  cursor: not-allowed;
  background-color: transparent !important;
}
.Modules_bundlesListItem__hpDjJ .title {
  margin: 0.5rem 1rem 1rem 0.5rem;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.Modules_bundlesListItem__hpDjJ .title input {
  margin-top: 0;
  flex-shrink: 0;
}
.Modules_bundlesListItem__hpDjJ .title .title-label {
  flex-shrink: 1;
  margin-right: 1rem;
}
.Modules_bundlesListItem__hpDjJ .content {
  padding: 0rem 1rem 1rem 2rem;
  display: block;
}
.Modules_bundlesListItem__hpDjJ .content .content-row {
  display: flex;
  gap: 1rem;
  align-items: start;
  justify-content: start;
}
.Modules_bundlesListItem__hpDjJ .content .content-row .content-controls {
  min-width: 5rem;
  --bs-btn-border-radius: .15rem;
  visibility: hidden;
}

.Modules_selectAtLeastOneModule__bXExi {
  color: red;
  margin-top: 8px;
  margin-bottom: 16px;
}

.Modules_selectRemainingModulesMessage__1o03Y {
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #D3D6D8;
  background-color: #E2E3E5;
}

.Modules_possibleCombinationsMessage__JaDyz {
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #BADBCC;
  background-color: #BADBCC;
  color: #0F5132;
}

.Modules_switcherWrapper__yp-Ki {
  margin-left: 16px;
  padding-top: 4px;
}

.Modules_groupModulesList__G0e\\+N {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
}
.Modules_groupModulesListItem__Kcwn\\+ {
  display: flex;
  margin-right: 6px;
  flex: 0 0 auto;
}
.Modules_groupModulesListItemText__6FpCK {
  display: inline-block;
  margin-right: 6px;
}

.Modules_clipboardWrapper__7kXNh {
  margin: 0.5rem 1rem 0.9rem 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Modules/Modules.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,8BAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,gBAAA;EACA,qBAAA;EChBE,gBAAA;EACA,iBAAA;ADeJ;ACbI;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ADeR;ACZI;EACI,gBAAA;ADcR;ACXI;EACI,yBAAA;EACA,gBAAA;ADaR;;AANE;EACE,YAAA;EACA,qBAAA;ECxBA,gBAAA;EACA,iBAAA;ADkCJ;AChCI;EACI,aAAA;EACA,cAAA;EACA,6BAAA;ADkCR;AC/BI;EACI,gBAAA;ADiCR;AC9BI;EACI,yBAAA;EACA,gBAAA;ADgCR;;AAjBA;EACE,+BAAA;AAoBF;AAlBE;EACE,yBAAA;AAoBJ;;AAhBA;EACE,kBAAA;EACA,cAAA;AAmBF;AAjBE;EACE,yBAAA;AAmBJ;AAjBI;EACE,8BAAA;AAmBN;AAfE;EACE,yBAAA;AAiBJ;AAbI;EACE,mBAAA;EACA,wCAAA;AAeN;AAXE;EACE,+BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAaJ;AAXI;EACE,aAAA;EACA,cAAA;AAaN;AAVI;EACE,cAAA;EACA,kBAAA;AAYN;AARE;EACE,4BAAA;EACA,cAAA;AAUJ;AARI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;AAUN;AARM;EACE,eAAA;EACA,8BAAA;EACA,kBAAA;AAUR;;AAJA;EACE,UAAA;EACA,eAAA;EACA,mBAAA;AAOF;;AAJA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAOF;;AAJA;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;AAOF;;AAJA;EACE,iBAAA;EACA,gBAAA;AAOF;;AAJA;EACE,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAOF;AALE;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AAOJ;AALI;EACE,qBAAA;EACA,iBAAA;AAON;;AAFA;EACE,4BAAA;AAKF","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n@import '../../styles/mixins.scss';\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  width: auto;\n  padding-top: calc(#{$navbarHeight} + 32px);\n}\n\n.tabsContainer {\n  width: 290px;\n}\n\n.tabs {\n  max-height: 50vh;\n  padding-right: .5rem;\n\n  @include custom-scrollbar();\n}\n\n.modulesContainer {\n  .moduleThumbnails {\n    height: 55vh;\n    padding-right: .5rem;\n\n    @include custom-scrollbar();\n  }\n}\n\n.modulesListTitle {\n  padding-left: .5rem !important;\n\n  &:has(div > input:checked) {\n    background-color: #E9F5F1;\n  }\n}\n\n.bundlesListItem {\n  position: relative;\n  display: block;\n\n  &:hover {\n    background-color: #F8F9FA;\n\n    :global(.content-controls) {\n      visibility: visible !important;\n    }\n  }\n\n  &:has(label>input:checked) {\n    background-color: #E9F5F1;\n  }\n\n  &:has(label>input:disabled) {\n    label {\n      cursor: not-allowed;\n      background-color: transparent !important;\n    }\n  }\n\n  :global(.title) {\n    margin: .5rem 1rem 1rem .5rem;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n\n    input {\n      margin-top: 0;\n      flex-shrink: 0;\n    }\n\n    :global(.title-label) {\n      flex-shrink: 1;\n      margin-right: 1rem;\n    }\n  }\n\n  :global(.content) {\n    padding: 0rem 1rem 1rem 2rem;\n    display: block;\n\n    :global(.content-row) {\n      display: flex;\n      gap: 1rem;\n      align-items: start;\n      justify-content: start;\n\n      :global(.content-controls) {\n        min-width: 5rem;\n        --bs-btn-border-radius: .15rem;\n        visibility: hidden;\n      }\n    }\n  }\n}\n\n.selectAtLeastOneModule {\n  color: red;\n  margin-top: 8px;\n  margin-bottom: 16px;\n}\n\n.selectRemainingModulesMessage {\n  padding: 12px;\n  border-radius: 5px;\n  border: 1px solid #D3D6D8;\n  background-color: #E2E3E5;\n}\n\n.possibleCombinationsMessage {\n  padding: 12px;\n  border-radius: 5px;\n  border: 1px solid #BADBCC;\n  background-color: #BADBCC;\n  color: #0F5132;\n}\n\n.switcherWrapper {\n  margin-left: 16px;\n  padding-top: 4px;\n}\n\n.groupModulesList {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  flex-wrap: wrap;\n\n  &Item{\n    display: flex;\n    margin-right: 6px;\n    flex: 0 0 auto;\n\n    &Text {\n      display: inline-block;\n      margin-right: 6px;\n    }\n  }\n}\n\n.clipboardWrapper {\n  margin: 0.5rem 1rem 0.9rem 0;\n}","@mixin custom-scrollbar {\n    overflow-y: auto;\n    margin-right: 1px;\n\n    &::-webkit-scrollbar {\n        width: 0.5rem;\n        height: 0.5rem;\n        background-color: transparent;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 0;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: #bec2c5;\n        border-radius: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `Modules_contentContainer__2xSzA`,
	"tabsContainer": `Modules_tabsContainer__rUGLa`,
	"tabs": `Modules_tabs__QlKMh`,
	"modulesContainer": `Modules_modulesContainer__NF-Rw`,
	"moduleThumbnails": `Modules_moduleThumbnails__03jQ1`,
	"modulesListTitle": `Modules_modulesListTitle__L3P2o`,
	"bundlesListItem": `Modules_bundlesListItem__hpDjJ`,
	"selectAtLeastOneModule": `Modules_selectAtLeastOneModule__bXExi`,
	"selectRemainingModulesMessage": `Modules_selectRemainingModulesMessage__1o03Y`,
	"possibleCombinationsMessage": `Modules_possibleCombinationsMessage__JaDyz`,
	"switcherWrapper": `Modules_switcherWrapper__yp-Ki`,
	"groupModulesList": `Modules_groupModulesList__G0e+N`,
	"groupModulesListItem": `Modules_groupModulesListItem__Kcwn+`,
	"groupModulesListItemText": `Modules_groupModulesListItemText__6FpCK`,
	"clipboardWrapper": `Modules_clipboardWrapper__7kXNh`
};
export default ___CSS_LOADER_EXPORT___;
